//MyRightModal
import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import {
  Dialog,
  DialogContent,
  Slide,
  DialogTitle,
  DialogActions,
  Button,
  Typography,
  Tooltip,
  IconButton,
} from "@material-ui/core";

import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
const styles = (theme) => ({
  dialog: {
    margin: "0px 0px 0px auto",
    right: "0px",
    left: "auto",
    [theme.breakpoints.up("md")]: {
      width: "25%",
    },
  },
  DialogTitle: {
    padding: "10px 24px",
  },
  myTitle: {
    float: "left",
    color: "#ffffff",
    fontStyle: "normal",
    fontWeight: "bold",
    fontSize: "18px!important",
    lineHeight: "18px",
    marginTop: "9px",
  },
  closeIcon: {
    padding: "5px",
    color: "#ffffff",
    cursor: "pointer",
    float: "right",
  },
  dialogcontent: {
    backgroundColor: "#fcfcfc",
    padding: "1rem 1.5rem",
  },
  // saveButton: {
  //   color: "#ffffff",
  //   padding: "10px 22px",
  // },
  // closeButton: {
  //   color: "#ffffff",
  //   padding: "10px 22px",
  // },
  closesaveButton: {
    color: "#ffffff",
    padding: "8px 14px",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "15px",
    lineHeight: "15px",
  },
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

class MyRightModal extends Component {
  render() {
    const { classes, children } = this.props;
    return (
      <Dialog
        className={classes.dialog}
        maxWidth="sm"
        fullScreen
        open={this.props.open || false}
        onClose={this.props.onClose}
        TransitionComponent={Transition}
      >
        <DialogTitle
          style={{
            backgroundColor: this.props.bgColor ? this.props.bgColor : "gray",
          }}
          className={classes.DialogTitle}
        >
          <Typography className={classes.myTitle} variant="h4">
            {this.props.title}
          </Typography>

          <Tooltip arrow title="Close">
            <IconButton
              className={classes.closeIcon}
              size="small"
              onClick={this.props.onClose}
            >
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </DialogTitle>

        <DialogContent className={classes.dialogcontent} dividers>
          {children}
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            color="primary"
            size="medium"
            //onClick={this.props.handleApprove}
            startIcon={<CloseIcon />}
            style={{ backgroundColor: "white", fontWeight:700,fontStyle:"initial" }}
            className={classes.closeButton}
          >
            Send Request
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(styles)(MyRightModal);
